import Button from "./Button";
import { Plus } from "lucide-react";

function AddButton({ children = "Add", ...props }) {
  return (
    <Button {...props}>
      <Plus className="w-4 h-4" /> {children}
    </Button>
  );
}

export default AddButton;
